// axios
import axios from 'axios';
// @ts-ignore
import Cookies from "js-cookie";

export const MakePay = async (data: any) => {
    // config
    let AuthConfig: any = {
        headers: {
            AccessKey: 'd2a77b9e92a64f0d9c3e7b2f3ed4b678',
            Authorization: `Bearer ${Cookies.get('makeToken')}`,
        }
    };
    const { data: response } = await axios.post(`https://apigateway.irantarakonesh.ir/Merchant/InvoiceHDMerchants`, data, AuthConfig);
    return response;
};
